//BD: Pergunta
export const enum EGuidPerguntaFixa {
  'QualTipoMinuta' = 'bd87715c-d229-4747-b1d3-e817f46fec97', // Qual o tipo de minuta ?
}
